module.exports = __webpack_public_path__ + "Titillium-SemiboldUpright.ae2d47f339469490da50.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Titillium-SemiboldUpright.otf
// module id = 379
// module chunks = 8